import React, { useCallback, useEffect, useState } from 'react'
import { Button, Checkbox, Divider, Fab, FormControlLabel, Grid, InputAdornment, Paper, TextField, Tooltip, Typography } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import RemoveIcon from '@material-ui/icons/Remove'
import { useParams } from 'react-router'

import useRouter from 'utils/useRouter'
import useStyles from './styles'
import { ModalConfirmacao } from 'components'

export const FormAdicionarQuesitos = (props) => {
  const { aberto, setExamesSolicitados, exameSolicitado, setOpen } = props
  const [quesitos, setQuesitos] = useState([])
  const [formErro, setFormErro] = useState(false)
  const classes = useStyles()

  useEffect(() => {
    if (exameSolicitado) {
      if (exameSolicitado.quesitos?.length) {
        setQuesitos(exameSolicitado.quesitos?.map((quesito, index) => ({ id: index, quesito: quesito.quesito })))
      } else {
        setQuesitos([{ id: 0, quesito: '' }])
      }
    }
  }, [exameSolicitado])

  const confirmar = () => {
    setExamesSolicitados((prevState) =>
      prevState.map((exame) => {
        if (exame.uuid === exameSolicitado.uuid) {
          return {
            ...exame,
            quesitos: quesitos,
          }
        }
        return exame
      })
    )

    setOpen(false)
  }

  const adicionarQuesito = () => {
    const maiorValor = quesitos.length ? quesitos[quesitos.length - 1].id : 0
    setQuesitos((prevState) => [...prevState, { id: maiorValor + 1, quesito: '' }])
  }

  const handleChange = (value, id) => {
    setQuesitos(
      quesitos.map((quesito) => {
        if (id === quesito?.id) {
          return {
            ...quesito,
            quesito: value,
          }
        }
        return quesito
      })
    )
  }

  const removerQuesito = (id) => {
    setQuesitos(quesitos.filter((q) => q.id !== id))
  }

  const renderQuesitosFields = () => (
    <Grid container spacing={2}>
      <Grid item md={12} sm={12} xs={12} className={classes.areaQuesitos}>
        {quesitos.map((quesito, index) => (
          <TextField
            key={quesito.id}
            fullWidth
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
            className={classes.item}
            label={`QUESITO`}
            name={quesito}
            onChange={(e) => handleChange(e.target.value, quesito?.id)}
            value={quesito?.quesito}
            InputProps={{
              endAdornment: index + 1 === quesitos.length && (
                <>
                  <InputAdornment position="start" style={{ marginLeft: '10px' }}>
                    <Tooltip title="Remover quesito">
                      <Fab color="secondary" size="small" onClick={() => removerQuesito(quesito.id)} className={classes.botaoAddFiliacao}>
                        <RemoveIcon />
                      </Fab>
                    </Tooltip>
                  </InputAdornment>
                  <InputAdornment position="start">
                    <Tooltip title="Adicionar quesito">
                      <Fab color="primary" size="small" onClick={() => adicionarQuesito()} className={classes.botaoAddFiliacao}>
                        <AddIcon />
                      </Fab>
                    </Tooltip>
                  </InputAdornment>
                </>
              ),
            }}
          />
        ))}
      </Grid>
    </Grid>
  )

  if (aberto !== undefined) {
    return (
      <ModalConfirmacao
        aberto={aberto}
        onClose={() => setOpen(false)}
        onConfirm={confirmar}
        disabled={formErro}
        titulo="Quesitos do exame"
        maxWidth="md"
        confirmarColor="primary"
        cancelarColor="error"
      >
        {renderQuesitosFields()}
      </ModalConfirmacao>
    )
  }

  return (
    <Grid container lg={12} md={12} sm={12} xs={12} spacing={2}>
      <Grid item>
        <Typography>
          <b>Quesitos do exame</b>
        </Typography>
      </Grid>
      {renderQuesitosFields()}
      <Grid item container justifyContent="space-between" className={classes.botoesFormulario}>
        <Grid item>
          <Button variant="contained" onClick={() => setOpen(false)} style={{ backgroundColor: '#984B43', color: 'white' }}>
            Cancelar
          </Button>
        </Grid>
        <Grid item>
          <Button disabled={formErro} variant="contained" color="primary" onClick={() => confirmar()}>
            Confirmar
          </Button>
        </Grid>
      </Grid>
    </Grid>
  )
}
